import { ImageList, Stack, Typography } from "@mui/material";
import { orderBy } from "lodash";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import EntityItemBtn from "./EntityItemBtn";
import EntityItemMobile from "./EntityItemMobile";
import useGetEntities from "./useGetEntities";

// ----------------------------------------------------------------------

export const EntitiesStep = () => {
	const { entities } = useGetEntities();

	const isDesktop = useResponsive("up", "md");
	const isMobile = useResponsive("down", "sm");
	const { translate } = useLocales();

	const itemsList = () => {
		return orderBy(entities, "name").map((item) =>
			isMobile ? (
				<EntityItemMobile key={item.id} item={item} />
			) : (
				<EntityItemBtn key={item.id} item={item} />
			)
		);
	};

	return (
		<Stack sx={{ maxWidth: 800 }}>
			<Stack flexDirection={"row"} alignItems={"center"}>
				<Typography variant='h6' alignSelf={{ xs: "center", sm: "flex-start" }} sx={{ ml: 2 }}>
					{translate("customization.select_entity")}
				</Typography>
			</Stack>

			<ImageList cols={isDesktop ? 4 : isMobile ? 1 : 2} sx={{ mt: 2, pb: 2 }}>
				{itemsList()}
			</ImageList>
		</Stack>
	);
};

export default EntitiesStep;
